import React from 'react';
import { object, oneOfType, array, func } from 'prop-types';
import withColor from 'util/hoc/with-color';
import withConfig from 'util/hoc/with-config';
import { resolve } from 'library/helpers/path-resolver';
import { Arrow } from 'library/styles/components/arrow';
import Logout from 'library/helpers/logout';
import * as StyledCareerClustersLanding from 'apps/career-clusters/components/career-clusters-survey/survey-sections/styled-career-clusters-survey-landing';

const CareerClusterSurveyLanding = ({user, colors, startSurvey, toggleModal, configuration}) => {
  const instanceName = resolve(
    configuration,
    'environment/journey/entity/name',
  );

  const instanceTitle = resolve(
    configuration,
    'environment/journey/entity/title',
    `My${instanceName ? ` ${instanceName}` : ''} Journey`
  );

  const butFirstLetMelogout = async (where_to) => {
    await toggleModal();
    await Logout();
    window.location.href = where_to;
  };

  return (
    <StyledCareerClustersLanding.StyledCareerClustersLandingContainer>
      <h2>  {user ? `Hi ${user.first_name}, e` : 'E'}xplore likely career matches based on your interests and strengths with Career Clusters! </h2>
      <p> Career Clusters are groups of careers and jobs that share common factors, helping you to explore similar careers based on your preferences and skills. </p>
      <p> Duration: 15–25 minutes to answer three survey questions. </p>
      {
        user
          ?
          (
            <StyledCareerClustersLanding.StyledSurveyOptions>
              <StyledCareerClustersLanding.StyledGetStartedButton
                background={colors.primary}
                onClick={() => startSurvey(user.uuid)}
                color={colors.grey1}>  Get Started  <Arrow color={colors.grey1} />
              </StyledCareerClustersLanding.StyledGetStartedButton>
              <p> Not {user.first_name}?
                <a href={`${__ACCOUNT_URL__}/signout?continue=${__APPURL__}/journey/tools/career-clusters`} onClick={() => butFirstLetMelogout(`${__ACCOUNT_URL__}/signin?continue=${__APPURL__}/journey/tools/career-clusters`)}> Sign in with your account </a> or
                <a href={`${__ACCOUNT_URL__}/signup`} onClick={() => butFirstLetMelogout(`${__ACCOUNT_URL__}/auth/signup?continue=${__APPURL__}/journey/tools/career-clusters`)}> sign up </a> to save your results </p>
            </StyledCareerClustersLanding.StyledSurveyOptions>
          )
          : (
            <StyledCareerClustersLanding.StyledSurveyOptions>
              <StyledCareerClustersLanding.StyledGetStartedButton
                as={'a'}
                href={`${__ACCOUNT_URL__}/auth/signin?continue=${window.location.href}`}
                color={colors.secondary}
                background={colors.primary}
                width='250px'
              >
                Sign In to Save Results
                <Arrow color={colors.grey1} />
              </StyledCareerClustersLanding.StyledGetStartedButton>
              <p>
                New to { instanceTitle }?
                <a
                  style={{ color: colors.secondary }}
                  href={`${__ACCOUNT_URL__}/auth/signup?continue=${__APPURL__}/journey/tools/career-clusters`}
                >
                  Sign up
                </a>
              </p>
            </StyledCareerClustersLanding.StyledSurveyOptions>
          )
      }
    </StyledCareerClustersLanding.StyledCareerClustersLandingContainer>
  );
};

CareerClusterSurveyLanding.propTypes = {
  user: object,
  colors: array,
  startSurvey: func,
  toggleModal: func,
  configuration: object,
};

CareerClusterSurveyLanding.defaultProps = {
  user: null
}

export default withConfig(withColor(CareerClusterSurveyLanding));
